import { getWindow } from './general';

export const pushEventInfo = (analyticsEvent: any) => {
  if (analyticsEvent) {
    try {
      const digitalData = getWindow()?.digitalData;
      if (digitalData) {
        digitalData.event = digitalData.event || [];

        digitalData.event.push(analyticsEvent);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('DDO : Error in pushing the event info!!!', err);
    }
  }
};
